import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'createEmptyArray',
  standalone: true,
  pure: true,
})
export class CreateEmptyArrayPipe implements PipeTransform {
  transform(length: number): undefined[] {
    return Array.from({ length });
  }
}
